module.exports = __webpack_public_path__ + "static/media/icon_28_deletegroups.f2406a74.svg";